/**
 * Family Display Names — Backward Compatibility Re-export
 *
 * Canonical source moved to src/content/familyLabels.ts (BC-V-8 fix).
 * This file re-exports for backward compatibility with teacher-v2 consumers.
 */
export { FAMILY_DISPLAY_NAMES, humanizeFamilyId } from '../../../content/familyLabels';